
import { Options, Vue } from "vue-class-component";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { BulkController } from "@/app/ui/controllers/BulkController";

@Options({})
export default class ButtonUploadFile extends Vue {
  $refs!: {
    fileInput: HTMLInputElement;
  };

  isLoading = false;

  onClickUpload() {
    this.$refs.fileInput.click();
  }

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    MainAppController.showLoading();

    const file = input.files[0];
    const formData = new FormData();
    formData.append("file", file);

    this.isLoading = true;

    try {
      const result = await BulkController._onBulkUploadCsv({
        archiveType: "district-operational",
        activityName: file.name,
        archiveFile: file,
        startDate: "",
        endDate: "",
        isScheduler: false,
        customStatus: "",
        commoditySurchargeStatus: "",
        isBulkUploadForm: false
      });

      if (result === false) {
        throw new Error("Upload gagal");
      }

      // === SUCCESS ===
      MainAppController.setSnackbarMessage(`
    <div class='flex flex-col'>
      <div class='text-16px text-green-lp-400 font-bold'>Berhasil upload</div>
      <p class='text-12px text-green-lp-400'>File <b>“${file.name}”</b> berhasil diupload.</p>
    </div>
  `);
      MainAppController.setSnackbarPositivity(true);
      MainAppController.setSnackbarTimeout(3000);
      MainAppController.setSnackbarBackgroundColor("#E3FCEF");
      MainAppController.setSnackbarIconLeft("success-status");
      MainAppController.setSnackbar(true);
    } catch (error) {
      console.error("Upload gagal:", error);
      MainAppController.setSnackbarMessage(`
    <div class='flex flex-col'>
      <div class='text-16px text-red-lp-1200 font-bold'>Gagal upload</div>
      <p class='text-12px text-red-lp-1200'>${BulkController.errorMessage}</p>
    </div>
  `);
      MainAppController.setSnackbarPositivity(false);
      MainAppController.setSnackbarTimeout(3000);
      MainAppController.setSnackbarBackgroundColor("#FEE8E8");
      MainAppController.setSnackbarIconLeft("icon-check-circle-red");
      MainAppController.setSnackbar(true);
    } finally {
      this.isLoading = false;
      MainAppController.closeLoading();
      input.value = "";
      this.$emit("upload")
    }
  }
}
